import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Login from './components/Login/Login';
import Accounts from './components/Accounts/Accounts';
import MoveMoney from './components/MoveMoney/MoveMoney';
import Beneficiaries from './components/Beneficiaries/Beneficiaries';
import Amount from './components/Amount/Amount';
import SelectAccount from './components/SelectAccount/SelectAccount';
import PaymentMethods from './components/PaymentMethods/PaymentMethods';
import Confirmation from './components/Confirmation/Confirmation';
import { MoveMoneyProvider, MoveMoneyContext } from './context/MoveMoneyContext';
import { initiateMoveMoney } from './api';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <nav>
          <ul>
            <li><Link to="/">Login</Link></li>
            <li><Link to="/accounts">Accounts</Link></li>
            <li><Link to="/move-money">Move Money</Link></li>
          </ul>
        </nav>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/move-money/*" element={
            <MoveMoneyProvider>
              <MoveMoneyFlow />
            </MoveMoneyProvider>
          } />
        </Routes>
      </div>
    </Router>
  );
}

function MoveMoneyFlow() {
  const moveMoneyContext = React.useContext(MoveMoneyContext);

  // React.useEffect(() => {
  //   const init = async () => {
  //     const { transactionId } = await initiateMoveMoney();
  //     moveMoneyContext?.setTransactionId(transactionId);
  //   };
  //   init();
  // }, [moveMoneyContext]);

  return (
    <div>
      <h2>Move Money</h2>
      <Routes>
          <Route path="/" element={<Beneficiaries />} />
          <Route path="amount" element={<Amount />} />
          <Route path="select-account" element={<SelectAccount />} />
          <Route path="payment-methods" element={<PaymentMethods />} />
          <Route path="confirmation" element={<Confirmation />} />
      </Routes>
    </div>
  )
}

export default App;
